import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../api/axiosInstance";

const AddEditDepartmentMaster = ({
  editingData,
  groupId,
  onClose,
  onSuccess,
}) => {

  /* ================= USER ================= */
  let storedUser = {};
  try {
    storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    storedUser = {};
  }

  /* ================= STATE ================= */
  const [departmentName, setDepartmentName] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= REFS ================= */
  const nameRef = useRef(null);
  const saveRef = useRef(null);

  /* ================= TITLE CASE ================= */
  const toTitleCase = (text = "") => {
    return text
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    if (editingData) {
      setDepartmentName(editingData.departmentName || "");
    } else {
      setDepartmentName("");
    }

    setTimeout(() => {
      nameRef.current?.focus();
    }, 200);
  }, [editingData]);

  /* ================= ESC CLOSE ================= */
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  /* ================= KEY NAV ================= */

  const handleNameKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      saveRef.current?.focus();
    }
  };

  const handleSaveKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }

    if (e.key === "Escape") {
      e.preventDefault();
      nameRef.current?.focus();
    }
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async () => {

    if (loading) return;

    if (!groupId)
      return alert("Group not found. Please login again.");

    if (!departmentName.trim())
      return alert("Enter department name");

    if (departmentName.trim().length < 2)
      return alert("Department name must be at least 2 characters");

    try {
      setLoading(true);

      const payload = {
        groupId: groupId,
        departmentId: editingData?.departmentId || 0,
        departmentName: toTitleCase(departmentName),
        userId: storedUser?.userId ?? 0,
      };

      await axiosInstance.post(
        "/DepartmentMaster/UpsertDepartment",
        payload
      );

      onSuccess?.();
      onClose?.();

    } catch (err) {

      console.error("Save error:", err);

      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Save failed";

      alert(message);

    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">

      <div className="bg-white w-full max-w-lg rounded-xl shadow-xl p-5">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-4">

          <h2 className="text-lg font-bold text-slate-800">
            {editingData ? "Edit Department" : "Add Department"}
          </h2>

          <button
            onClick={onClose}
            className="text-slate-500 hover:text-red-600 text-xl"
          >
            ✕
          </button>

        </div>

        {/* FORM */}
        <div className="space-y-4">

          {/* NAME */}
          <div>

            <label className="text-sm font-medium text-slate-700">
              Department Name *
            </label>

            <input
              ref={nameRef}
              type="text"
              value={departmentName}
              onChange={(e) =>
                setDepartmentName(e.target.value.replace(/\s+/g, " "))
              }
              onBlur={() =>
                setDepartmentName((v) => toTitleCase(v))
              }
              onKeyDown={handleNameKey}
              className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
              placeholder="Enter department name"
            />

          </div>

          {/* ACTIONS */}
          <div className="flex justify-end gap-3 pt-2">

            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg border text-sm hover:bg-slate-100"
            >
              Cancel
            </button>

            <button
              ref={saveRef}
              onClick={handleSubmit}
              onKeyDown={handleSaveKey}
              disabled={loading}
              className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-700 disabled:opacity-60"
            >
              {loading ? "Saving..." : "Save"}
            </button>

          </div>

        </div>

      </div>

    </div>
  );
};

export default AddEditDepartmentMaster;

